import React from 'react';
import 'antd/dist/antd.css';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import './stylesheets/global.scss';
import Loading from './Loading';
const loading = () => <Loading loadingStatus={true} />;

const Registration = React.lazy(() => import('./Register'));
const SpecialNeedsRegistrations = React.lazy(() => import('./SpecialNeedsRegistrations'));

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <React.Suspense fallback={loading()}>
          <Switch>
            <div>
              <Route path="/soct" name="Home" render={props => <Registration {...props}/>} />
              <Route path="/9131" name="Registration" render={props => <SpecialNeedsRegistrations {...props}/>} />
            </div>
          </Switch>
        </React.Suspense>
      </BrowserRouter>
     
    </div>
  );
}

export default App;
